import {Probability, RootCauseType, VoteList, Node} from '@domain/rcfa'

export enum CanvasMode {
  default = 'default',
  hand = 'hand'
}

export interface CanvasLevel {
  nodes: Array<RcfaCanvasNode>
  level: number
}

export interface GraphLink {
  source: Node
  target: Node
}

export interface RcfaCanvasNode {
  attachmentCount: number
  causeProbability: Probability
  children: Array<number>
  collapsed: boolean
  commentCount: number
  cx: number
  cy: number
  dependsOn: Array<number>
  description: string
  hasCollapsedAncestors?: boolean
  id: number
  index?: number
  isOnPathToRootCauseFrom?: Array<number>
  rootCauseType?: RootCauseType
  level: number
  order: number
  parent?: number
  position: number
  taskCount: number
  title: string
  totalTree: number
  votes: VoteList | undefined
}
